import { connect } from 'react-redux'
import ProductPricing from '../../../components/products/details/product/details/pane/ProductPricing'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    pricing: ownProps.pricing
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPricing)



// WEBPACK FOOTER //
// ./src/containers/products/productdetail/ProductPricing.ts